import React, { Component } from 'react';

class RightBar_Examples extends Component {

  constructor(props) {
    super(props);
    this.state = {
      
    };
  }

  getTranslatedContent(langCode){
    if(!["he", "en"].includes(langCode)){ // setting langCode to "en" if invalid code given
      langCode = "en";
    }
	    var retVal;
	    if(langCode === "he"){
	      retVal = <>

        <p className="MsoNormal" dir="RTL" style={{textAlign: 'right', direction: 'rtl', unicodeBidi: 'embed'}}><b><u>חיפוש מעורפל עם ניקוד חלקי</u></b></p>
        <p className="MsoNormal" dir="RTL" style={{textAlign: 'right', direction: 'rtl', unicodeBidi: 'embed'}}>
          בחר <b>אותיות</b> ו<b>נקודות</b>, הזן מונח שבו רק חלק מהנקודות מפורטות, והעבר את מחוון הדיוק ל<b>מעורפל</b>. החיפוש שומר על הנקודות שהוזנו אך מאפשר גמישות בחלקים שלא פורטו, בדומה להוספת תו <b>*</b> מפורש במקומות הגמישים.
        </p>
        
	      </>
	    } else if (langCode === "en") {
	      retVal = <>

        <p className="MsoNormal"><b><u>Fuzzy Search with Partial Nekudos</u></b></p>
        <p className="MsoNormal">Select <b>Letters</b> and <b>Nekudos</b>, enter a term with only some of its nekudos specified, and move the exactness slider to <b>Fuzzy</b>. The entered nekudos remain required while unspecified portions stay flexible, similar to placing an explicit <b>*</b> in the flexible parts of the pattern.</p>

	      </>
    }
    return retVal;
  }
  
  render() {
    return <>
      {this.getTranslatedContent(this.props.langCode)}
    </>
  }
}

export default RightBar_Examples;
